import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
export function PracticeApproach() {
  const {
    t
  } = useLanguage();
  const a = t.approach;
  return <section aria-labelledby="approach-title" className="bg-cream py-24 md:py-32" data-id="element-253" data-mp="1pzws96yc62t9">
      <div className="mx-auto grid max-w-7xl gap-14 px-6 md:px-10 lg:grid-cols-12 lg:gap-20" data-id="element-254" data-mp="1uv3o5sld637m">
        <div className="lg:col-span-5" data-id="element-255" data-mp="1zvhvt9j1zb54">
          <h2 id="approach-title" className="font-display text-[30px] font-medium leading-[1.2] tracking-[-0.01em] text-ink md:text-[36px]" data-id="element-256" data-mp="128r84fld4od5">
            {a.title}
          </h2>
          <p className="mt-5 text-[17px] text-muted" data-id="element-257" data-mp="1c6f5zee9mbzj">{a.intro}</p>

          <aside className="mt-12 rounded-[20px] bg-white p-7" data-id="element-258" data-mp="1gxf2wjndwu21">
            <div className="flex items-center gap-3" data-id="element-259" data-mp="1gyyj6a91j53t">
              <span aria-hidden="true" className="h-2.5 w-2.5 rounded-full bg-sage" data-id="element-260" data-mp="jijc0hg2yy6g" />
              <h3 className="font-display text-[17px] font-medium text-ink" data-id="element-261" data-mp="oh4aocfop9ss">{a.kinesiology.title}</h3>
            </div>
            <p className="mt-3 text-[15.5px] text-muted" data-id="element-262" data-mp="14ptm9b8p6it0">{a.kinesiology.body}</p>
          </aside>
        </div>

        <dl className="lg:col-span-7" data-id="element-263" data-mp="zr8hcyii3ay8">
          {a.items.map(item => <div key={item.title} className="grid gap-2 border-t border-line py-7 last:border-b sm:grid-cols-[200px_1fr] sm:gap-8" data-id="element-264" data-mp="uyywhww8t12t">
              <dt className="font-display text-[19px] font-medium text-violet-deep" data-id="element-265" data-mp="pyjj55byntku">{item.title}</dt>
              <dd className="text-[16.5px] text-charcoal" data-id="element-266" data-mp="lwfxxozhpamd">{item.body}</dd>
            </div>)}
        </dl>
      </div>
    </section>;
}